import { useMutation } from "@tanstack/react-query";
import { mutationKeys } from "PFCore/hooks/queries/shortlists/mutation_keys";
import { rankedShortlistsKeys, shortlistsKeys } from "PFCore/hooks/queries/shortlists/query_keys";
import { ShortlistUpdatePayload, updateShortlist } from "PFCore/services/shortlist";
import { Id } from "PFTypes/id";
import { MutationOptions } from "PFTypes/request_options";

type ShortlistUpdateParams = {
  id: Id;
  data: ShortlistUpdatePayload;
};

type UseShortlistUpdate = {
  activityId: Id;
  options?: MutationOptions<ShortlistUpdateParams, unknown>;
};

export const useShortlistUpdate = ({ options = {}, activityId }: UseShortlistUpdate) =>
  useMutation({
    mutationKey: mutationKeys.update(),
    mutationFn: ({ id, data }: ShortlistUpdateParams): Promise<unknown> => updateShortlist(id, data),
    ...options,
    meta: {
      invalidation: {
        replace: true,
        composeQueryKeys: () => [
          shortlistsKeys.activityShortlists(activityId),
          shortlistsKeys.activitySuspendedShortlists(activityId),
          rankedShortlistsKeys.activityRankedShortlists(activityId)
        ]
      }
    }
  });
